const initialState = {
  JWT: '',
  email: '',
  previousPage: '',
};

export default initialState;
